module.exports = __webpack_public_path__ + "img/gsg-logo-white.bceed63b.png";